import React from 'react';
import languageNames from '../modules/languagenames';

const LocationBar = (props) => {
  let text;
  let languageName;

  if (props.exercises.activeExercise !== null) {
    const exercise = props.exercises.exercises[props.exercises.activeExercise];
    const description = (exercise.group_id === null) ? 'Personal exercise' : 'Group exercise';
    languageName = languageNames[exercise.language] || exercise.language;
    text = `${description}: ${exercise.name}.`;
    text += ` (${languageName})`;

    if (exercise.mode === 'flipped') {
      text += ` Flipped mode. Try once before you can listen to the example.`;
    }
  }

  return (
    <div className="pronounce-location">
      {text}
    </div>
);
};

export default LocationBar;



// WEBPACK FOOTER //
// ./src/components/LocationBar.js